import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import Profile from '../../pages/profile/profile.container'
import Materials from '../../pages/materials/materials.container'
import Membership from '../../pages/membership/membership'
import School from '../../pages/school/school.container'
import OauthCallback from '../../pages/profile/oauth/oauth-callback/oauth-callback.container'
import PageNotFound from 'pobble-components/dist/page-not-found'

const Routes = ({ showMembership, isParent }) => {
  return (
    <Switch>
      <Route exact path="/" component={Profile} />
      <Route exact path="/profile" component={Profile} />
      <Route exact path="/materials" component={Materials} />
      {isParent &&
        showMembership && (
          <Redirect exact from="/membership" to="/membership/parent" />
        )}
      {showMembership && (
        <Route
          exact
          path={['/membership', '/membership/moderation', '/membership/parent']}
          component={Membership}
        />
      )}
      <Route
        exact
        path={[
          '/school/',
          '/school/team',
          '/school/edit',
          '/school/data',
          '/school/tools',
          '/school/add-pupils'
        ]}
        component={School}
      />
      <Route exact path="/oauth-callback/:provider" component={OauthCallback} />
      <Route component={PageNotFound} />
    </Switch>
  )
}

export default Routes
